module.exports = __webpack_public_path__ + "img/27222B_677491_484F6A_5D657A-256px.6aaf1768.png";